module.exports = __webpack_public_path__ + "static/gelistirdigimizcozumler-43b23276b574ec5a2486574f8d152add.png";